var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowupicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 4,
    viewBox: "0 0 8 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4L4 0L8 4H0Z",
    fill: "#8C9EBA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowupicon);
export default __webpack_public_path__ + "static/media/arrowupicon.aeeebe99729cf04b292ced9d3de5a272.svg";
export { ForwardRef as ReactComponent };